// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setTokenAndUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { nav("/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/emergent/session", { session_id });
        setTokenAndUser(data.token, data.user);
        window.history.replaceState(null, "", "/dashboard");
        nav(data.user.role === "client" ? "/dashboard" : "/admin", { replace: true, state: { user: data.user } });
      } catch (e) {
        nav("/login?err=oauth");
      }
    })();
  }, [location, nav, setTokenAndUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="glass rounded-xl px-8 py-6 text-white/70 text-sm">Signing you in…</div>
    </div>
  );
}
